import useI18n from '@/src/hooks/use_i18n'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'

export default function CheckPrivacyModal({
  show,
  handleClose,
  handleAgree
}: {
  show: boolean
  handleClose: () => void
  handleAgree: () => void
}) {
  const { $t, i18nFormatAll } = useI18n()

  return (
    <div>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>{$t('ResConsolePIndex.global.__modalTitle')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p
            dangerouslySetInnerHTML={{
              __html: i18nFormatAll($t('ResConsolePIndex.global.__privacyDesc'), {
                0: `<a target="_blank" href="https://www.17track.net/helpcenter/licensing">${$t(
                  'ResConsolePIndex.global.__privacy01'
                )}</a>`,
                1: `<a target="_blank" href="https://www.17track.net/helpcenter/privacy">${$t(
                  'ResConsolePIndex.global.__privacy02'
                )}</a>`
              })
            }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" style={{ background: '#f8f9fa' }} onClick={handleClose}>
            {$t('ResConsolePIndex.global.__modalCancel')}
          </Button>
          <Button variant="primary" onClick={handleAgree}>
            {$t('ResConsolePIndex.global.__iAgree')}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}
